var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewsletter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H15C16.1046 3 17 3.89543 17 5V18.5C17 19.8807 18.1193 21 19.5 21V21ZM19.5 21L20 21V21C21.6568 20.9998 23 19.6567 23 17.9999V17.9999C23 16.3431 21.6571 15 20.0004 15C19.837 15 19.6699 15 19.5 15M7 14.0882H13M7 17H11.5M17 4C18.1046 4 19 4.89543 19 6V17M19 17V18.0908C19 18.5929 19.4071 18.9999 19.9092 18.9999L20.0002 18.9999C20.5524 18.9998 21 18.5521 21 17.9999C21 17.4477 20.5523 17 20.0001 17H19ZM8.64406 8.33343L6.5 8L7.97299 11.3692L12.5 10.4638V6.72274L10.8809 7.8328L9.35207 6.38006L8.64406 8.33343Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsletter);
export default __webpack_public_path__ + "static/media/newsletter.4ce93d20b3b45a484d89f5c06749f7e5.svg";
export { ForwardRef as ReactComponent };